import { isString } from "../utils/schemaUtils";

export interface LinearTeam {
  id: string;
  // The short prefix Linear puts on every issue identifier, e.g. "ENG".
  key: string;
  name: string;
  // A private team only appears here when an admin granted the app access.
  private: boolean;
}

const isLinearTeam = (v: unknown): v is LinearTeam => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.key) && isString(r.name) && typeof r.private === "boolean";
};

export interface LinearTeamsPayload {
  type: "linear_teams";
  teams: LinearTeam[];
}

export const parseLinearTeamsPayload = (v: unknown): LinearTeamsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_teams") return null;
  if (!Array.isArray(r.teams) || !r.teams.every(isLinearTeam)) return null;
  return {
    type: "linear_teams",
    teams: r.teams,
  };
};
